import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FileTypeDto } from '@coin/importer/dto/util';
import { PopupAction } from '@coin/importer/core/util';
import { APIGatewayResponse } from '@coin/importer/core/data-access';
import { FileTypePopupComponent } from '../../components/file-type-popup/file-type-popup.component';
import { FileTypeService } from '../../services/file-type/file-type.service';
import { ToastService } from '../../services/toast/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SubHeaderComponent } from '../../components/sub-header/sub-header.component';
import { ButtonFooterComponent } from '../../components/button-footer/button-footer.component';
import { ChartsComponent } from '../../components/charts/charts.component';
import { FiletypeOverviewComponent } from '../../components/filetype-overview/filetype-overview.component';
import { V2ButtonComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'importer-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SubHeaderComponent, V2ButtonComponent, ButtonFooterComponent, ChartsComponent, FiletypeOverviewComponent]
})
export class SettingsComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly fileTypeService = inject(FileTypeService);
  private readonly toast = inject(ToastService);
  private readonly _matDialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);
  loading = true;

  // eslint-disable-next-line no-restricted-syntax
  async ngOnInit(): Promise<void> {
    if (!this.fileTypeService.fileTypeSubject$.getValue()?.length) {
      await this.fileTypeService.loadFileTypesToSubject();
    }
    this.loading = false;
  }

  openDashboardPage(): void {
    this.router.navigate(['']);
  }

  // for testing
  deleteObjects(item: FileTypeDto): void {
    this.fileTypeService
      .deleteObjects(item)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: APIGatewayResponse) => {
        if (res.statusCode) {
          const { message } = JSON.parse(res.body);
          if (res.statusCode === 409) {
            this.toast.info(message);
          } else {
            this.toast.error(message);
          }
        }
      });
  }

  openCreateFileTypePopup(): void {
    const item = { exportAttributes: [], emailAddress: [] } as FileTypeDto;
    this._matDialog.open(FileTypePopupComponent, {
      data: { item, action: PopupAction.New }
    });
  }
}
